import * as React from 'react';

import './Testemunhos.css';

export default function Testemunhos() {
    return (
        <div>
            <div className="full-screen-section">
                <p>O que dizem as pessoas, quando estão ébrias e pensam na Dodô?</p>
            </div>
            <div className="half-screen-section">
                <h3>Uma pessoa fixe, guerreira, minha madrinha, calma eu tô pensando tá um pouco lento. É uma pessoa
                    muito fixe e eu gosto muito dela.</h3>
                <p>Borracha</p>
            </div>
            <div className="half-screen-section">
                <h3>Minha mãe da universidade.</h3>
                <p>Visigodo</p>
            </div>
            <div className="half-screen-section">
                <h3>Festa, boa disposição, convívios, música, outfits slay</h3>
                <p>Júlia</p>
            </div>
            <div className="half-screen-section">
                <h3>Festa, convívio, acolhimento, inclusão, ela aproxima-se de toda a gente, toda a gente pode ser
                    próximo dela, acabado de chegar ou já estão aqui há muito tempo ela tenta sempre aproximar-se</h3>
                <p>Luna</p>
            </div>
            <div className="half-screen-section">
                <h3>Resiliência. Fim. É tudo o que tenho a dizer sobre a dodô. Se ela não souber o que siginfica
                    resiliência pode ir pesquisar o significado mas resiliência significa ultrapassar os objectivos que
                    tem mesmo que seja difícil</h3>
                <p>Catapulta</p>
            </div>
            <div className="half-screen-section">
                <h3>Diversão</h3>
                <p>Remy</p>
            </div>
            <div className="half-screen-section">
                <h3>Penso em alegria, ecstasy, estar sempre a curtir ela é sempre alto astral, vou ter muitas saudades
                    dela tenho muita pena dela ir embora e tenho pena dos novos projetos não a conhecerem como nós
                    tivemos oportunidade de a conhecer</h3>
                <p>Butija</p>
            </div>
            <div className="half-screen-section">
                <h3>Então, isto é bué difícil porque ela tá sempre aqui como é que eu vou fazer isto não percebo não dá.
                    Então vou-vos explicar uma cena.
                    Thank you.
                    Thank you o caralho não me deixam entrar no McDonald’s
                    Eu vou vos explicar uma coisa
                    Okay! Não sei onde é a padaria, estou em Praga neste momento, Praga centro, vou perguntar a este
                    senhor sem abrigo se dá para comer, não, se calhar estou a ser antipática. Tou a ser muito
                    antipática. Não, malta, eu sou uma pessoa séria e educada. Mentira, sou séria não sou educada, não,
                    eu sou educada não é áspera. Não. Estou cheia de sede.
                    I want you baby, nananana I want you baby.
                    É assim eu vou-vos explicar uma coisa, eu adoro a Dodô, adoro a família Dodô e companhia, só não
                    gostei, epá esta merda é muito pequena tão a perceber porque, é pequena, não dá para descrever
                    (????) a Dodô. Porque a Dodô é tão quê, é tão o o universo é tão pequeno que não dá para descrever.
                    A Dodô sou eu. Solteira mas eu também tou. Não. A Dodô sou é se eu tivesse de descrever a Dodô não
                    sei não conseguia. Porque a Dodô sou eu. Eu adoro a Dodô, a Dodô está no meu coração. Literalmente
                    tá mesmo no meu coração tipo amo essa pessoa. Muito. Não. Mas tipo de uma maneira que é tipo até me
                    dá raiva tipo dá me vontade de fazer punch punch punch punch punch. Dá bué. Tipo. Porque é que eu
                    gosto dessa gaja? Ela tá a olhar para mim tipo damn girl. Egocêntrica de merda. Tão a perceber que
                    nojo.</h3>
                <p>Juanita</p>
            </div>
            <div className="half-screen-section">
                <h3>Dodô</h3><p style={{lineHeight: 0.0, fontSize: 10}}>(Quando perguntado &quot;O que pensas quando
                pensas na tua
                madrinha&quot;)</p>
                <p>ÀBrás</p>
            </div>
            <div className="half-screen-section">
                <h3>Amizade</h3>
                <p>ÀBrás (Sóbrio)</p>
            </div>
            <div className="half-screen-section">
                <h3>Não, não consigo pensar agora</h3>
                <p>Gadget</p>
            </div>
            <div className="half-screen-section">
                <h3>Primeira amizade verdadeira</h3>
                <p>Gadget (Sóbrio) </p>
            </div>
            <div className="half-screen-section">
                <h3>Companheirismo, uma pessoa que tá lá para te ajudar, que &quot;Got your back&quot;, ou seja penso
                    sempre no
                    companheirismo de preocupação para contigo e de te proteger</h3>
                <p>Guaca (Sóbrio)</p>
            </div>
            <div className="half-screen-section">
                <h3>Quando penso na Dodô penso no cão imaginário de Leiria, dos nossos testes de som (principalmente na
                    casa de banho), de comprar maços de cigarro para dar aos tunos e claro… a Dodô é a maior inimiga do
                    fim. Do fim do quê? Do fim da festa, da noite, dos copos. É atleta de alta de competição, acha que a
                    noite tem sempre ainda mais qualquer coisa para lhe dar e ela para oferecer.</h3>
                <p>Ainanas (Sóbria)</p>
            </div>
            <div className="half-screen-section">
                <h3>Alegre. Assertiva. Divertida. Líder. Justa. Proativa.
                    Gosto que estas características todas te façam pensar constantemente no dia e na tuna de amanhã. Se
                    temos pessoas para gerir e organizar, pessoas para socializar e pessoas para estarem presentes. Este
                    foco no amanhã é o que te define e ao teu percurso aos meus olhos</h3>
                <p>Alentejana (Sóbria)</p>
            </div>
            <div className="half-screen-section">
                <h3>É, tou eu a fazer isto e ainda tenho de meter uma coisa minha aqui no meio. Sabes que te adoro
                    pronto continua a ler</h3>
                <p>Fanã</p>
            </div>
            <div className="half-screen-section">
                <h3> para mim é mesmo muito difícil descrever esse tipo de coisas em relação a uma pessoa porque nunca
                    me soube exprimir muito bem mas, vem me a cabeça uma pessoa que brilha sem tentar brilhar. Penso em
                    conforto e em alguém que me inspira por ser um “role model” que supera as suas inseguranças. Penso
                    na capacidade que ela tem de ser an alma da festa e encaixar com todos, e lembro-me logo do momento
                    em que acho que me apeguei mais a ela que foi quando fomos guias juntas.</h3>
                <p>Janice (Sóbria)</p>
            </div>
            <div className="half-screen-section">
                <h3>A Dodô ensinou-me a ser resiliente, como ela. Ensinou-me que está tudo bem em precisarmos de tempo
                    para pensar sobre as coisas e que nem sempre precisamos de remar a favor da maré. Dodô é sinónimo de
                    até ao fim da festa, de manhãs em silêncio porque ainda é muito cedo e de trabalho árduo até tudo
                    ficar perfeito.</h3>
                <p>Fiona (Sóbria)</p>
            </div>
            <div className="half-screen-section">
                <h3>Olá, este é por, se acaso,não, então.Dodô olá, gostamos muito de ti (???) camisola preta</h3>
                <p>Juanita e Ná </p>
            </div>
            <div className="half-screen-section">
                <h3>Quando penso na Dodô, penso que é das únicas pessoas que para ser conquistada não é com elogios à
                    sua personalidade, ao que já fez na vida mas sim, ao seu rabo. Quem lhe elogia o rabo, tem tudo
                    dela.
                    É a mesma pessoa que consegue na mesma música, experimentar harmonias ou fazer o quadradinho ao
                    ritmo da mesma, principalmente nos “pa pa’s” da Sarandillera.</h3>
                <p>Koppus (Sóbrio)</p>
            </div>

            <div className="half-screen-section">
                <h3> Fogo diz me que tipo de coisas o pessoal anda a enviar. Não quero destoar muito</h3>
                <p>Koppus (Overthinker, a querer fazer melhor)</p>
            </div>
            <div className="half-screen-section">
                <h3>Dedicação, compromisso, espírito, empatia, alegria, são várias as palavras que me ocorrem quando
                    penso em ti Dodô. Acho que és uma pessoa formidável que passou nesta tuna, lembro-me de ti no
                    início,
                    quando chegaste, a aprender acordeão, ainda não sabias tocar acordeão, lembro-me deve ter sido ser
                    final de 2015, início de 2016 num retiro em estremoz, acho que foi em estremoz , desde aí foi um
                    prazer acompanhar a tua evolução. a Dodô de antigamente e a Dodô de agora sao a mesma pessoa mas com
                    atitudes muito diferentes. Se calhar até pessoas um bocado diferentes mas sempre foste uma excelente
                    pessoa sempre pronta a ouvir, e abriste-te muito a esta tuna e esta tuna vai ter muitas saudades
                    tuas e quero agradecer pelos momentos passados contigo e pelo que aquilo que desta a esta
                    maravailhosa e fantastica tuna, este grande grupo que vai sentir a tua falta de certeza.
                    Portanto bem vinda ao grupo dos cotas e vai ser um prazer acompanhar a tuna ao teu lado agora ao teu
                    lado para os mais novos, um beijinho e parabéns por todo o teu percurso </h3>
                <p>Gui (Sóbrio, creio)</p>
            </div>
            <div className="half-screen-section">
                <h3>Tuna sem Dodô? What the fuck?É que eu sinto que tu és tipo, uma mãe galinha. Só que discreta, tu
                    cuidas da tuna assim como se fosse a tua bebé com muito carinho, com muito amor, a proteger, mas
                    atrofias também com o pessoal e acho que fazes muito bem, fazes lembrar aquele vine (procede a
                    descrever este <a href="https://www.youtube.com/shorts/VRt16d94aR4">vine</a>). Tu atrofias com o
                    pessoal e atrofias muito bem, agora quem é que vai atrofiar
                    com o pessoal nos copos?Quem é que vai ser o last man standing? Vai ter de ser a tua linhagem? Um
                    deles não se aguenta em pé, o outro começa às cabeçadas. Vá o remy até que aguenta mas pah o
                    Borracha e o Visi ainda são os bacanos que aguentam mais pah. Agora como é que o pessoal vai seguir
                    o exemplo? Tem de haver alguém a picar, a mostrar que não é só best friends for ever e unicórnios.
                    Também é mas depois as vezes levas ali com um comentário, uma afrontadela, a gozar claramente e o
                    pessoal fica ali e tu começaste a rir e a pessoa também todo nervosinho, é isso que vai faltar. Acho
                    que vais ter de passar a tocha não sei a quem. Vou tentar adotar mas acho que não consigo tão bem .
                    Mentira, acho que a catapulta é capaz de conseguir um pouquinho mas é preciso limar. Dodô obrigado
                    genuinamente, obrigado por tudo. Diretamente e indiretamente sempre foste uma pessoa a seguir e
                    continuas a ser e obrigado mesmo por tudo. Ainda não processei acho que ainda não é real acho que
                    nem no Lisboa Eterna vai ser real, acho que vai ser so no festival que tu não fores. Acho que aí é
                    que me vai bater e cair tudo em cima. é muito bittersweet ainda não sei lidar, fodase Dodô não
                    desapareças</h3>
                <p>Ding (Sóbrio, mas exausto)</p>
            </div>
            <div className="half-screen-section">
                <h3>Quando penso na Dodô lembro-me dos óculos que ela tinha quando entrámos na Tuna. Lembro-me do cão
                    com ar jovem em Leiria. Lembro-me de ganhar uma maravilhosa vizinha na formação e da camaradagem :D
                    Lembro-me do trabalho em equipa (#RemarNoMesmoSentido), lembro-me das cantorias e das harmonias,
                    lembro-me de brindes e de jogos e quebra-cabeças, lembro-me das cumplicidades e das conversas,
                    lembro-me de noites que se tornaram dia (literal e figurativamente), lembro-me das partidas de 1 de
                    abril que não falhavam.
                    Quando penso na Dodô vejo alguém que se envolve e que explora, que protege as suas pessoas, que está
                    sempre disposto a alinhar em aventuras e que escolhe viver a vida de braços abertos
                </h3>
                <p>Pingu (Sóbria)</p>
            </div>
            <div className="half-screen-section">
                <h3>Quando penso na Dodo acho que aquilo que me vem primeiro à cabeça é ela estar sempre randomly lá. Lá
                    onde? Em festas, convívios, tudo. A quantidade de convívios de tunas ou lá na faculdade que do
                    nada dou por mim a beber copos com o pessoal da Taiscte estando ela sempre lá é incrível!... ATÉ NO
                    PAREDES DE COURA!

                    Para além disso é inevitável lembrar me dos nossos jogos de beer pong. Que, para ficar registado,
                    ela perdeu a maioria. Ainda temos desforras para fazer (e que vamos fazer!)
                </h3>
                <p>Sebastião (Sóbrio)</p>
            </div>
        </div>
    );
}
